import { Rectangle } from "../../maths/Rectangle";
import { ClassUtils } from "../../utils/ClassUtils";
import { Pool } from "../../utils/Pool";
export class DrawEllipseCmd {
    constructor() {
        this.lineWidth = 0;
    }
    static create(x, y, width, height, fillColor, lineColor, lineWidth, percent) {
        var cmd = Pool.getItemByClass("DrawEllipseCmd", DrawEllipseCmd);
        cmd.x = x;
        cmd.y = y;
        cmd.width = width;
        cmd.height = height;
        cmd.fillColor = fillColor;
        cmd.lineColor = lineColor;
        cmd.lineWidth = lineWidth;
        cmd.percent = percent;
        return cmd;
    }
    recover() {
        this.fillColor = null;
        this.lineColor = null;
        Pool.recover("DrawEllipseCmd", this);
    }
    run(context, gx, gy) {
        let offset = (this.lineWidth >= 1 && this.lineColor) ? this.lineWidth / 2 : 0;
        if (this.percent && context.sprite) {
            let w = context.sprite.width;
            let h = context.sprite.height;
            context._drawEllipse(this.x * w + gx, this.y * h + gy, this.width * w - offset, this.height * h - offset, this.fillColor, this.lineColor, this.lineWidth);
        }
        else {
            context._drawEllipse(this.x + gx, this.y + gy, this.width - offset, this.height - offset, this.fillColor, this.lineColor, this.lineWidth);
        }
    }
    get cmdID() {
        return DrawEllipseCmd.ID;
    }
    getBounds(assembler) {
        let rect = Rectangle.TEMP.setTo(this.x - this.width, this.y - this.height, this.width * 2, this.height * 2);
        if (this.percent) {
            rect.scale(assembler.width, assembler.height);
            assembler.affectBySize = true;
        }
        rect.getBoundPoints(assembler.points);
    }
}
DrawEllipseCmd.ID = "DrawEllipse";
ClassUtils.regClass("DrawEllipseCmd", DrawEllipseCmd);
